import { render, staticRenderFns } from "./ButtonContained.vue?vue&type=template&id=295a930d&"
import script from "./ButtonContained.vue?vue&type=script&lang=ts&"
export * from "./ButtonContained.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports